import { merge } from "lodash/fp";
import { HubThemePartial } from "../../types";
import hkmaThemeBase from "./_base";

const hkmaTheme: HubThemePartial = merge(hkmaThemeBase, {
  meta: {
    config: {
      featureSet: {
        tracking: {
          plausible: {
            enabled: true,
            allowLocalTracking: false,
            siteDomain: "app.climaterisk.hk",
          },
        },
      },
      portfolioExport: {
        assetLevelDeepDive: {
          outputTypes: ["small", "exposures", "screen"],
        },
      },
    },
  },
} as HubThemePartial);

export default hkmaTheme;
